import { useTranslation } from "react-i18next";
import Header from "../components/Header";

import "./index.scss";

const MessagePage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Header />
      <div className="message-page">
        <div className="message-content">
          <div className="message-text">{t("requestAcess.message")}</div>
        </div>
      </div>
    </div>
  );
};

export default MessagePage;
